//
import FamilyModel from '@/models/Warehouse/WhFamily'
import SubfamilyModel from '@/models/Warehouse/WhSubfamily'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
export default ({ g_branch_office_id, triggerWarehouse }) => [
    {
        name: 'alias_search',
        type: 'text-field',
        props: {
            label: 'Alias',
        },
    },
    {
        name: 'internal_code',
        type: 'text-field',
        props: {
            label: 'Código Interno',
        },
    },
    {
        name: 'upc_code',
        type: 'text-field',
        props: {
            label: 'Código UPC',
        },
    },
    {
        name: 'of_warehouse',
        type: 'autocomplete-model',
        props: {
            chips: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noObject: true,
            paramFilter: {
                g_branch_office_id,
            },
        },
        trigger: triggerWarehouse,
    },
    {
        name: 'wh_family_id',
        type: 'autocomplete-model',
        props: {
            chips: true,
            itemText: 'family',
            itemValue: 'id',
            label: 'Familia',
            model: FamilyModel,
            noObject: true,
        },
    },
    {
        name: 'wh_subfamily_id',
        type: 'autocomplete-model',
        props: {
            chips: true,
            itemText: 'subfamily',
            itemValue: 'id',
            label: 'Sub Familia',
            model: SubfamilyModel,
            noObject: true,
            paramSearch: 'subfamily',
        },
    },
    {
        name: 'is_salable',
        type: 'select',
        props: {
            chips: true,
            items: [
                {
                    text: 'No',
                    value: 0,
                },
                {
                    text: 'Si',
                    value: 1,
                },
            ],
            label: 'Vendible',
        },
    },
    {
        name: 'is_repackaged',
        type: 'select',
        props: {
            chips: true,
            items: [
                {
                    text: 'No',
                    value: false,
                },
                {
                    text: 'Si',
                    value: true,
                },
            ],
            label: 'Reenvasable',
        },
    },
    {
        name: 'is_consumable',
        type: 'select',
        props: {
            chips: true,
            items: [
                {
                    text: 'No',
                    value: false,
                },
                {
                    text: 'Si',
                    value: true,
                },
            ],
            label: 'Consumible',
        },
    },    
    {
        name: 'product_provider_code',
        type: 'text-field',
        props: {
            label: 'Código de proveedor',
        },
    },
]
